import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { ICarWashObject } from "../../../../../types/carWash";

interface DeleteCarWashDialogProps {
  open: boolean;
  carWash: ICarWashObject | null;
  onConfirm: () => void;
  onCancel: () => void;
  loading?: boolean;
}

const DeleteCarWashDialog = ({
  open,
  carWash,
  onConfirm,
  onCancel,
  loading = false,
}: DeleteCarWashDialogProps) => {
  const { t } = useTranslation();
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      aria-labelledby="delete-dialog-title"
      aria-describedby="delete-dialog-description"
    >
      <DialogTitle id="delete-dialog-title">
        {t("common.confirmDelete")}
      </DialogTitle>
      <DialogContent>
        <Typography>
          {t("ownerScreens.deleteCarWashConfirm", {
            name: carWash?.legalName ?? "",
          })}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
          {t("common.actionCannotBeUndone")}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} color="primary" disabled={loading}>
          {t("common.cancel")}
        </Button>
        <Button
          onClick={onConfirm}
          color="error"
          variant="contained"
          disabled={loading}
        >
          {loading ? t("common.deleting") : t("common.delete")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteCarWashDialog;

